
export enum EventList {
  SingleOptinClick = 'singleOptinClick',
  DoubleOptinClick = 'doubleOptinClick',
  SingleOptinDone = 'singleOptinDone',
  DoubleOptinDone = 'doubleOptinDone',
  CoiOptinDone = 'coiOptinDone'
}
